import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=09238ab7&scoped=true"
import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"
import style0 from "./switch.vue?vue&type=style&index=0&id=09238ab7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09238ab7",
  null
  
)

export default component.exports